





































































































































import Vue from 'vue'
import './VersionSummary.scss'
import SubscribeRelease from '@/mixins/SubscribeRelease'
import { Col, Row, Button } from 'element-ui'
import { Version } from '@/store/types'
import { KeyDict } from '@/types'

enum ServiceState {
  UNKNOWN = 'unknown',
  RUNNING = 'running',
  OFFLINE = 'offline'
}

interface ParsedServiceInfo {
  time: string,
  state: ServiceState,
  tooltip: string
}

export default Vue.extend({
  name: 'VersionSummary',
  mixins: [SubscribeRelease],
  props:{
    version: {
      type: String,
      required: true
    }
  },
  data: () => ({
    columnsize: [6, 18],
    expanded: true
  }),
  computed: {
    release (): Version | null {
      return this.$store.direct.state.admin.release?.versions[this.version] ?? null
    },
    id (): string {
      if (this.release === null) return 'unknown'
      return this.release.id
    },
    frontendBranch (): string {
      if (this.release === null) return 'unknown'
      return this.release.branch_front
    },
    backendBranch (): string {
      if (this.release === null) return 'unknown'
      return this.release.branch_back
    },
    backendMachine (): string {
      if (this.release === null) return 'unknown'
      return this.release.machine_back ?? 'no machine running'
    },
    hasFirestoreRules (): boolean {
      if (this.release === null) return false
      return this.release.deploy_firebase?.rules ?? false
    },
    hasFirestoreFunctions (): boolean {
      if (this.release === null) return false
      return this.release.deploy_firebase?.functions ?? false
    },
    hasManifests (): boolean {
      if (this.release === null) return false
      return this.release.deploy_firebase?.manifests ?? false
    },
    machinetooltip (): string {
      return 'Login on the machine with the dev key and the ubuntu user'
    },
    backendCommit (): string {
      if (this.release === null) return 'unknown commit'
      return this.release?.commit_back ?? 'unknown commit'
    },
    backendDeployTime (): string {
      if (this.release === null) return 'unknown'
      return this.release?.deployment_date_back?.toDate().toDateString() ?? 'unknown'
    },
    serviceState (): KeyDict<ParsedServiceInfo> {
      if (this.release === null) return {}
      const states: KeyDict<ParsedServiceInfo> = {}
      Object.keys(this.servicesEnabled).forEach(serviceid => {
        if (this.release === null) return
        let state = ServiceState.UNKNOWN
        let time = 'unknown'
        const serviceInfo = this.release.services_info
        const service = serviceInfo ? serviceInfo[serviceid] : undefined
        if (service !== undefined) {
          state = service.running ? ServiceState.RUNNING : ServiceState.OFFLINE
          time = service?.last_changed_timestamp?.toDate().toDateString() ?? 'unknown'
        }
        const tooltip = `Wanted state is ${this.servicesEnabled[serviceid]}, real state is ${state} (last update time: ${time})`
        states[serviceid] = {
          state,
          time,
          tooltip
        }
      })
      return states
    },
    servicesEnabled (): KeyDict<boolean> {
      if (this.release === null) return {}
      return this.release.services_enabled ?? {}
    },
    ngcvpVersion (): string {
      if (this.release === null) return 'no-version'
      return this.release.ngcvp_version ?? 'no-version'
    }
  },
  methods: {
    switchRules (): void {
      this.$confirm('Are you sure you want to use this branch for the security rules?' +
                    'You need to go to jenkins and deploy it again before it takes effect!', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$store.direct.dispatch.admin.setReleaseFirestoreRules(this.version)
        this.$message({
          type: 'success',
          message: 'This branch is now responsible for the security rules, please deploy it again in jenkins'
        })
      }).catch(() => {
        //
      })
    },
    switchFunctions (): void {
      this.$confirm('Are you sure you want to use this branch for the cloud functions?' +
                    'You need to go to jenkins and deploy it again before it takes effect!', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$store.direct.dispatch.admin.setReleaseFirestoreFunctions(this.version)
        this.$message({
          type: 'success',
          message: 'This branch is now responsible for the cloud function, please deploy it again in jenkins'
        })
      }).catch(() => {
        //
      })
    },
    switchManifests (): void {
      this.$confirm('Are you sure you want to use this branch for the manifests?' +
                    'You need to go to jenkins and deploy it again before it takes effect!', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$store.direct.dispatch.admin.setReleaseManifests(this.version)
        this.$message({
          type: 'success',
          message: 'This branch is now responsible for the manifests, please deploy it again in jenkins'
        })
      }).catch(() => {
        //
      })
    },
    toggleService (service: string): void {
      this.$confirm(`Are you sure you want to use this branch to run the ${service} serrvice?` +
                    'This will take effect immediately', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$store.direct.dispatch.admin.setReleaseService({ version: this.version, service })
        this.$message({
          type: 'success',
          message: `This service is now running the service ${service}`
        })
      }).catch(() => {
        //
      })
    },
    updateNgCVPVersion (): void {
      this.$prompt('Please input the ngcvp version you want to use', 'The preset name', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel'
      // @ts-ignore
      }).then(({ value }) => {
        this.$store.direct.dispatch.admin.setNGCVPForRelease({ version: this.version, ngcvpVersion: value}).then(() => {
          this.$message({
            type: 'success',
            message: 'The ngcvp version is upated to ' + value
          })
        }).catch(() => {})
      }).catch(() => {
        //
      })
    }
  },
  components: {
    'el-col': Col,
    'el-row': Row,
    'el-button': Button
  }
})
